import React from 'react'
import style from './style.module.less'

const Text = ({ text }) => {
  return (
    <div className={style.text}>
      {!text && (
        <p className={style.placeholder}>
          请输入婚礼设计的灵感构思以及婚礼布置的元素
        </p>
      )}
      <p className={style.main}>{text}</p>
    </div>
  )
}

export default Text
